﻿

(function ($, document, undefined) {
    $(document).ready(function () {
        $(document).on('click', '[data-show-hide]', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $panel = $($this.data('show-hide'));
            var style = $this.data('show-hide-style');
            var isVisible = $panel.is(':visible');
            if (style == 'class') {
                isVisible = !$panel.hasClass('hidden');
            }

            if (isVisible) {
                switch (style) {
                    case "class":
                        $panel.addClass('hidden');
                        break;
                    case "hide":
                    default:
                        $panel.hide();
                        break;
                }
                $this.removeClass('active');
                if ($this.data('show-hide-text-hidden')) {
                    $this.text($this.data('show-hide-text-hidden'));
                }
            } else {
                $this.addClass('active');
                if ($this.data('show-hide-self')) {
                    $this.hide();
                }
                var style = $this.data('show-hide-style');
                switch (style) {
                    case "class":
                        $panel.removeClass('hidden');
                        break;
                    case "hide":
                    default:
                        $panel.show();
                        break;
                }

                if ($this.data('show-hide-text-visible')) {
                    $this.text($this.data('show-hide-text-visible'));
                }
            }
        });
    });
})(jQuery, document);